import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuthSession } from "./kernel-context";

/**
 * Rota protegida. Reativa: expiração/logout em outra aba redirecionam na hora.
 *
 * Com `passwordChangePath`, sessão com senha provisória (`mustChangePassword`)
 * só acessa essa rota — o backend recusa todo o resto até a troca.
 */
export function RequireAuth({
  children,
  redirectTo = "/login",
  passwordChangePath,
}: {
  children: ReactNode;
  redirectTo?: string;
  passwordChangePath?: string;
}) {
  const session = useAuthSession();
  const location = useLocation();

  if (!session) {
    return (
      <Navigate to={redirectTo} replace state={{ from: location.pathname + location.search }} />
    );
  }
  if (
    passwordChangePath &&
    session.mustChangePassword &&
    location.pathname !== passwordChangePath
  ) {
    return (
      <Navigate
        to={passwordChangePath}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return <>{children}</>;
}
